import pearl1 from '../assets/pearlpebbels/pearl1.webp';
import pearl2 from '../assets/pearlpebbels/pearl2.webp';
import pearl3 from '../assets/pearlpebbels/pearl3.webp';
import pearl4 from '../assets/pearlpebbels/pearl4.webp';
import pearl5 from '../assets/pearlpebbels/pearl5.webp';

import white1 from '../assets/whitepebbels/white1.webp';
import white2 from '../assets/whitepebbels/white2.webp';
import white3 from '../assets/whitepebbels/white3.webp';
import white4 from '../assets/whitepebbels/white4.webp';
import white5 from '../assets/whitepebbels/white5.webp';
import white6 from '../assets/whitepebbels/white6.webp';
import white7 from '../assets/whitepebbels/white7.webp';
import white8 from '../assets/whitepebbels/white8.webp';

import riverpebbles1 from '../assets/riverpebbelstone/riverpebbles1.webp';
import riverpebbles2 from '../assets/riverpebbelstone/riverpebbles2.webp';
import riverpebbles3 from '../assets/riverpebbelstone/riverpebbles3.webp';
import riverpebbles4 from '../assets/riverpebbelstone/riverpebbles4.webp';
import riverpebbles5 from '../assets/riverpebbelstone/riverpebbles5.webp';

import riverstones1 from '../assets/riverpebbelstone/riverstones1.webp';
import riverstones2 from '../assets/riverpebbelstone/riverstones2.webp';
import riverstones3 from '../assets/riverpebbelstone/riverstones3.webp';

import gray1 from '../assets/graypebbels/gray1.webp';
import gray2 from '../assets/graypebbels/gray2.webp';
import gray3 from '../assets/graypebbels/gray3.webp';
import gray4 from '../assets/graypebbels/gray4.webp';
import gray5 from '../assets/graypebbels/gray5.webp';
import gray6 from '../assets/graypebbels/gray6.webp';

import extra1 from '../assets/extraimgs/extra1.webp';
import extra2 from '../assets/extraimgs/extra2.webp';
import extra3 from '../assets/extraimgs/extra3.webp';
import extra4 from '../assets/extraimgs/extra4.webp';
import extra5 from '../assets/extraimgs/extra5.webp';

import polished1 from '../assets/polished/polished1.webp';
import polished2 from '../assets/polished/polished2.webp';
import polished3 from '../assets/polished/polished3.webp';
import polished4 from '../assets/polished/polished4.webp';  
import polished5 from '../assets/polished/polished5.webp';
import polished6 from '../assets/polished/polished6.webp';

import car1 from '../assets/webimgs/car1.webp';
import car2 from '../assets/webimgs/car2.webp';
import car3 from '../assets/webimgs/car3.webp';
import car4 from '../assets/webimgs/car4.webp';

import f1 from '../assets/frames/f1.webp';
import f2 from '../assets/frames/f2.webp';
import f3 from '../assets/frames/f3.webp';
import f4 from '../assets/frames/f4.webp';  
import f5 from '../assets/frames/f5.webp';
import f6 from '../assets/frames/f6.webp';

import bould1 from '../assets/boulders/bould1.webp';
import bould2 from '../assets/boulders/bould2.webp';
import bould3 from '../assets/boulders/bould3.webp';
import bould4 from '../assets/boulders/bould4.webp';  
import bould5 from '../assets/boulders/bould5.webp';
import bould6 from '../assets/boulders/bould6.webp';

import stat1 from '../assets/statues/stat1.webp';
import stat2 from '../assets/statues/stat2.webp';
import stat3 from '../assets/statues/stat3.webp'; 
import stat4 from '../assets/statues/stat4.webp';
import stat5 from '../assets/statues/stat5.webp';
import stat6 from '../assets/statues/stat6.webp';

import { BiUser } from "react-icons/bi";

export const Vols = [
  { id: 1,
    image: car1, 
    desc1: "From the Nature", 
    desc2: "To Your Decor" },
  {
    id: 2,
    image: car2,
    desc1: "Add Timeless Elegance",
    desc2: "To Every Space",
  },
  { id: 3, 
    image: car3, 
    desc1: "Nature’s Beauty", 
    desc2: "Crafted In stone" 
  },
  { id: 4, 
    image: car4, 
    desc1: "Stones that Speak ", 
    desc2: "To Your Style" 
  },
];

export const Infidata = [
  {
    title: "John Doe",
    image: <BiUser />,
    review: "These pebble stones transformed my garden beautifully!",
  },
  {
    title: "Sarah Lee",
    image: <BiUser />,
    review: "Amazing quality and fast delivery. Highly recommended.",
  },
  {
    title: "Sam",
    image: <BiUser />,
    review: "Amazing quality and fast delivery. Highly recommended.",
  },
  {
    title: "Pb",
    image: <BiUser />,
    review: "Amazing quality and fast delivery. Highly recommended.",
  },
  {
    title: "xyz",
    image: <BiUser />,
    review: "These pebble stones transformed my garden beautifully!",
  },

];

export const footerlink = [
  { id: 1, title: "About", link: "/about" },
  { id: 2, title: "Contact", link: "/contact" },
  { id: 3, title: "Privacy Policy", link: "/privacypolicy" },
  { id: 4, title: "Terms of Service", link: "/termsofservice" },
];


export const galleryData = [
  {
    id: 1,
    sectionTitle: "Pearl Pebbles",
    sectionDescription: "Elegant pearl pebbles ideal for indoor decoration, aquariums, and landscaping projects.",
    images: [
      {
        id: 1,
        url: pearl1,
        title: "Pearl / White / mixed pebbels",
        description: "Pebbles — perfect for planters and interior decor."
      },
      {
        id: 2,
        url: pearl2,
        title: "Pearl Mixed (Small)",
        description: "A mix of small pearl pebbles ideal for fillers, borders, and aquascaping."
      },
      {
        id: 3,
        url: pearl3,
        title: "Pearl Large Pebbles",
        description: "Larger sized pearl pebbles suitable for outdoor landscaping."
      },
      {
        id: 4,
        url: pearl4,
        title: "Pearl mixed Pebbles",
        description: "Larger sized pearl pebbles suitable for outdoor landscaping."
      },
      {
        id: 5,
        url: pearl5,
        title: "Pearl Large Pebbles",
        description: "Larger sized pearl pebbles suitable for outdoor landscaping."
      },
    ]
  },

  {
    id: 2,
    sectionTitle: "White Pebbles",
    sectionDescription: "Classic white pebbles that add brightness and elegance to gardens, pathways, and interiors.",
    images: [
      {
        id: 1,
        url: white1,
        title: "White Polished Round",
        description: "Round polished white stones, commonly used in decorative pots and fountains."
      },
      {
        id: 2,
        url: white2,
        title: "White Natural Pebbles",
        description: "Unpolished white stones giving a raw, natural look to any landscape."
      },
      {
        id: 3,
        url: white3,
        title: "White Natural Pebbles",
        description: "Unpolished white stones giving a raw, natural look to any landscape."
      },
      {
        id: 4,
        url: white4,
        title: "White Natural Pebbles",
        description: "Unpolished white stones giving a raw, natural look to any landscape."
      },
      {
        id: 5,
        url: white5,
        title: "White Natural Pebbles",
        description: "Unpolished white stones giving a raw, natural look to any landscape."
      },
      {
        id: 6,
        url: white6,
        title: "White Natural Pebbles",
        description: "Unpolished white stones giving a raw, natural look to any landscape."
      },
      {
        id: 7,
        url: white7,
        title: "White Natural Pebbles",
        description: "Unpolished white stones giving a raw, natural look to any landscape."
      },
      {
        id: 8,
        url: white8,
        title: "White Natural Pebbles",
        description: "Unpolished white stones giving a raw, natural look to any landscape."
      },
    ]
  },

  {
    id: 3,
    sectionTitle: "River Stones / Pebbles",
    sectionDescription: "Naturally shaped and smoothed by rivers, these stones bring an organic touch to any space.",
    images: [
      {
        id: 1,
        url: riverpebbles1,
        title: "River Mixed Pebbles",
        description: "Multi-colored river pebbles, suitable for both indoor and outdoor decorative use."
      },
      {
        id: 2,
        url: riverpebbles2,
        title: "River Black Smooth",
        description: "Smooth black river stones ideal for spa, landscaping, and aquarium use."
      },
      {
        id: 3,
        url: riverpebbles3,
        title: "Flat River Stones",
        description: "Flat-shaped river stones often used in pathways and decorative flooring."
      },
      {
        id: 4,
        url: riverpebbles4,
        title: "Flat River Stones",
        description: "Flat-shaped river stones often used in pathways and decorative flooring."
      },
      {
        id: 5,
        url: riverpebbles5,
        title: "Flat River Stones",
        description: "Flat-shaped river stones often used in pathways and decorative flooring."
      },
      {
        id: 6,
        url: riverstones1,
        title: "Flat River Stones",
        description: "Flat-shaped river stones often used in pathways and decorative flooring."
      },
      {
        id: 7,
        url: riverstones2,
        title: "Flat River Stones",
        description: "Flat-shaped river stones often used in pathways and decorative flooring."
      },
      {
        id: 8,
        url: riverstones3,
        title: "Flat River Stones",
        description: "Flat-shaped river stones often used in pathways and decorative flooring."
      },
    ]
  },

  {
    id: 4,
    sectionTitle: "Gray Pebbles",
    sectionDescription: "Subtle and elegant gray pebbles used for modern landscaping and interiors.",
    images: [
      {
        id: 1,
        url: gray1,
        title: "Gray Polished",
        description: "Polished gray stones that give a refined look to pathways and garden beds."
      },
      {
        id: 2,
        url: gray2,
        title: "Gray Natural Matte",
        description: "Natural matte finish pebbles perfect for minimalist indoor decor."
      },
      {
        id: 3,
        url: gray3,
        title: "Gray Natural Matte",
        description: "Natural matte finish pebbles perfect for minimalist indoor decor."
      },
      {
        id: 4,
        url: gray4,
        title: "Gray Natural Matte",
        description: "Natural matte finish pebbles perfect for minimalist indoor decor."
      },
      {
        id: 5,
        url: gray5,
        title: "Gray Natural Matte",
        description: "Natural matte finish pebbles perfect for minimalist indoor decor."
      },
      {
        id: 6,
        url: gray6,
        title: "Gray Natural Matte",
        description: "Natural matte finish pebbles perfect for minimalist indoor decor."
      },
    ]
  },

  {
    id: 5,
    sectionTitle: "Pebble Art Frames",
    sectionDescription: "Frames made with artistic arrangements of pebbles, perfect for unique home decor.",
    images: [
      {
        id: 1,
        url: f1,
        title: "Pebble Art Frame 1",
        description: "Artistic frame made using decorative pebbles."
      },
      {
        id: 2,
        url: f2,
        title: "Pebble Art Frame 2",
        description: "Artistic frame made using decorative pebbles."
      },
      {
        id: 3,
        url: f3,
        title: "Pebble Art Frame 3",
        description: "Artistic frame made using decorative pebbles."
      },
      {
        id: 4,
        url: f4,
        title: "Pebble Art Frame 4",
        description: "Artistic frame made using decorative pebbles."
      },
      {
        id: 5,
        url: f5,
        title: "Pebble Art Frame 5",
        description: "Artistic frame made using decorative pebbles."
      },
      {
        id: 6,
        url: f6,
        title: "Pebble Art Frame 6",
        description: "Artistic frame made using decorative pebbles."
      },
    ]
  },

  {
    id: 6,
    sectionTitle: "Stone Boulders / Flooring",
    sectionDescription: "Boulders perfect for landscaping, garden features, and outdoor decor. Also have flooring / parking stones ",
    images: [
      {
        id: 1,
        url: bould1,
        title: "Stone Boulder 1",
        description: "Large stone boulder perfect for garden landscaping."
      },
      {
        id: 2,
        url: bould2,
        title: "Stone Boulder  2",
        description: "Large stone boulder perfect for garden landscaping."
      },
      {
        id: 3,
        url: bould3,
        title: "Stone Boulder 3",
        description: "2 different types of large stone boulders."
      },
      {
        id: 4,
        url: bould4,
        title: "Flooring marble stones",
        description: "marble stones ideal for flooring."
      },
      {
        id: 5,
        url: bould5,
        title: "Flooring marble stones",
        description: "marble stones ideal for flooring."
      },
      {
        id: 6,
        url: bould6,
        title: "Parking stones",
        description: "Stones ideal for parking areas and driveways."
      }
    ]
  },

  {
    id: 7,
    sectionTitle: "Polished Stones / Pebbles",
    sectionDescription: "Polished stones and pebbles perfect for decorative purposes, bowls, aquariums, and showpieces.",
    images: [
      {
        id: 1,
        url: polished1,
        title: "Decorative Stones",
        description: "Stones commonly used in bowls, aquariums, and showpieces."
      },
      {
        id: 2,
        url: polished2,
        title: "Our Collection",
        description: "Our decorative pebbele and stones."
      },
      {
        id: 3,
        url: polished3,
        title: "Decorative Stones",
        description: "Closer look at our decorative stones collection."
      },
      {
        id: 4,
        url: polished4,
        title: "Polished Stones",
        description: "Polished stones ideal for decorative purposes."
      },
      {
        id: 5,
        url: polished5,
        title: "Polished Stones",
        description: "Polished stones ideal for decorative purposes."
      },
      {
        id: 6,
        url: polished6,
        title: "Polished Stones",
        description: "Polished stones ideal for decorative purposes."
      },
    ]
  },

  {
    id: 8,
    sectionTitle: "Statues and Sculptures",
    sectionDescription: "Stone statues and sculptures that add an artistic touch to gardens and outdoor spaces.",
    images: [
      {
        id: 1,
        url: stat1,
        title: "Stone Statue 1",
        description: "Stone statue adding an artistic touch to gardens and outdoor spaces."
      },
      {
        id: 2,
        url: stat2,
        title: "Stone Statue 2",
        description: "Stone statue adding an artistic touch to gardens and outdoor spaces."
      },
      {
        id: 3,
        url: stat3,
        title: "Stone Statue 3",
        description: "Stone statue adding an artistic touch to gardens and outdoor spaces."
      },
      {
        id: 4,
        url: stat4,
        title: "Stone Statue 4",
        description: "Stone statue adding an artistic touch to gardens and outdoor spaces."
      },
      {
        id: 5,
        url: stat5,
        title: "Stone Statue 5",
        description: "Stone statue adding an artistic touch to gardens and outdoor spaces."
      },
      {
        id: 6,
        url: stat6,
        title: "Stone Statue 6",
        description: "Stone statue adding an artistic touch to gardens and outdoor spaces."
      },
    ]
  },

  {
    id: 9,
    sectionTitle: "Extra Section",
    sectionDescription: "Miscellaneous images showcasing various decorative stones, pebbles and our branding.",
    images: [
      {
        id: 1,
        url: extra1,
        title: "From Exhibition",
        description: "Pictures from exhibition showcasing our decorative stones."
      },
      {
        id: 2,
        url: extra2,
        title: "From Exhibition",
        description: "Pictures from exhibition showcasing our decorative stones."
      },
      {
        id: 3,
        url: extra3,
        title: "Our packaging",
        description: "Our packing bags for decorative stones."
      },
      {
        id: 4,
        url: extra4,
        title: "Frame of pebble art",
        description: "Beautiful frame made using decorative pebbles."
      },
      {
        id: 5,
        url: extra5,
        title: "From Exhibition",
        description: "Pictures from exhibition showcasing our decorative stones."
      },
    ]
  }
];
